import React from 'react';
const Button = (props)=>{
    return (
        <>
            <button
      type={props.type || 'submit'}
      name={props.name || ''}
      style={props.style}
      disabled={props.disabled || false}
      onClick={props.onClick || (() => {})}
      className={`border-1 bg-[#059669]  rounded-md hover:transform transition duration-150 hover:scale-105 ${props.className || ''}`}
    >
      {props.PreSvgIcon || ""}{props.children || 'Button'}{props.PostSvgIcon || ""}
    </button>
        </>
    )
}
export default Button;